module.exports = __webpack_public_path__ + "img/dupay.7bea1eb0.png";